import { Breadcrumbs } from "../components/Breadcrumbs";

function Plano() {
    return (
        <div>
            <Breadcrumbs currentPage="Planos" />
            <header className="page-header">
                <h2 className="page-title">Gestão de Planos</h2>
            </header>
            <div className="table-placeholder">
                Módulo de Planos em construção.
            </div>
        </div>
    );
}

export default Plano;
